import React, { useEffect, useRef, useState } from "react";
import Checkbox from "../../../../shared/ui/inputs/checkbox.js";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import Description from "../description/description.js";
export default function Consents(props) {
    const [description, setDescription] = useState(null);
    const [error, showError] = useState("");
    const consentsChecked = useRef([false]);
    useEffect(() => {
        consentsChecked.current = new Array(props.consents.length).fill(false);
    }, [props.consents]);
    return (React.createElement("div", { className: "consents-container" },
        props.consents.map((consent, index) => (React.createElement("div", { key: index, className: "consent-box" },
            React.createElement("div", { className: "checkbox-container" },
                React.createElement(Checkbox, { onTrigger: (isChecked) => {
                        consentsChecked.current[index] = isChecked;
                    } })),
            consent.text,
            React.createElement("img", { className: "read-more-icon", about: "https://uxwing.com/ - super website", src: "../../assets/icons/open-more.svg", width: "20", alt: "dowiedz si\u0119 wi\u0119cej", onClick: () => {
                    setDescription(React.createElement(Description, { value: consent.description, onLeave: () => setDescription(null) }));
                } })))),
        React.createElement(Button, { text: "Otw\u00F3rz galeri\u0119", value: "open_gallery", onClick: () => {
                if (consentsChecked.current.some((c) => c == false)) {
                    showError("Wszystkie pola muszą być wypełnione");
                    return;
                }
                showError("");
                location.assign("/client/gallery");
            } }),
        error && React.createElement("span", { style: { color: "red" } }, error),
        description));
}
